var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
// @ts-nocheck
import React, { useEffect, useRef, useState } from "react";
import { Box, Button, Checkbox, CircularProgress, Dialog, DialogContent, FormControlLabel, Grid, IconButton, Tab, Tabs, TextField, Tooltip, Typography, Zoom, } from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { QRCodeSVG } from "qrcode.react";
import { useDataProvider, useLocale, useNotify } from "react-admin";
import { dialog } from "../../utils/componentWizard";
import { dbDateHelperWithHHMM } from "../../utils/helper";
var Transition = React.forwardRef(function Transition(props, ref) {
    return _jsx(Zoom, __assign({ ref: ref }, props));
});
var DEFAULT_DOWNLOAD_LIMIT = 1;
var DEFAULT_VALID_MINUTES = 10;
var DIALOG_WIDTH = 420;
var TAB_CONTENT_MIN_HEIGHT = 320;
var PRIMARY_BUTTON_MIN_WIDTH = 168;
var DIALOG_BORDER_RADIUS = "4px";
var SYSTEM_ACCENT = "#4d6a95";
var SYSTEM_DARK = "#1a2b42";
var dialogPaperSx = {
    backgroundColor: "rgba(255, 255, 255, 0.5)",
    "& .MuiDialog-paper": {
        borderRadius: DIALOG_BORDER_RADIUS,
        backgroundColor: "#FFFFFF",
        width: DIALOG_WIDTH,
        maxWidth: "95vw",
    },
};
var tabPanelSx = {
    minHeight: TAB_CONTENT_MIN_HEIGHT,
    display: "flex",
    flexDirection: "column",
    width: "100%",
    pb: 1,
};
var actionRowSx = {
    display: "flex",
    justifyContent: "center",
    mt: "auto",
    pt: 2,
    width: "100%",
};
var qrActionButtonSx = {
    minHeight: 40,
};
var qrDescriptionSx = {
    width: "85%",
    mx: "auto",
};
var emailReminderListSx = {
    m: 0,
    pl: 2.25,
    color: SYSTEM_ACCENT,
    "& li": {
        mb: 0.5,
        "&:last-child": {
            mb: 0,
        },
    },
};
var qrDescriptionRowSx = {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "baseline",
    width: "100%",
    gap: 1,
    mb: 0.75,
    "&:last-child": {
        mb: 0,
    },
};
var secondaryActionRowSx = {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: 1.5,
    width: "100%",
    mt: "auto",
    pt: 2,
};
var downloadQrAsPng = function (svgElement, filename) {
    if (filename === void 0) { filename = "share-report-qr.png"; }
    var svgData = new XMLSerializer().serializeToString(svgElement);
    var svgBlob = new Blob([svgData], { type: "image/svg+xml;charset=utf-8" });
    var url = URL.createObjectURL(svgBlob);
    var img = new Image();
    img.onload = function () {
        var canvas = document.createElement("canvas");
        canvas.width = img.width;
        canvas.height = img.height;
        var ctx = canvas.getContext("2d");
        ctx.fillStyle = "#ffffff";
        ctx.fillRect(0, 0, canvas.width, canvas.height);
        ctx.drawImage(img, 0, 0);
        canvas.toBlob(function (blob) {
            if (!blob)
                return;
            var link = document.createElement("a");
            link.href = URL.createObjectURL(blob);
            link.download = filename;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(link.href);
        }, "image/png");
        URL.revokeObjectURL(url);
    };
    img.onerror = function () { return URL.revokeObjectURL(url); };
    img.src = url;
};
var normalizeShareLanguage = function (language) {
    return language === "zh-HK" || language === "zh" ? "zh-HK" : "en";
};
var parseShareSettings = function (downloadLimit, validMinutes) {
    var parsedDownloadLimit = parseInt(String(downloadLimit), 10);
    var parsedValidMinutes = parseInt(String(validMinutes), 10);
    if (!parsedDownloadLimit ||
        parsedDownloadLimit < 1 ||
        !parsedValidMinutes ||
        parsedValidMinutes < 1) {
        return null;
    }
    return {
        download_limit: parsedDownloadLimit,
        valid_seconds: parsedValidMinutes * 60,
    };
};
var getShareReportUrl = function (token, _a) {
    var _b = _a === void 0 ? {} : _a, shareRecordId = _b.shareRecordId, _c = _b.passwordRequired, passwordRequired = _c === void 0 ? false : _c, _d = _b.language, language = _d === void 0 ? "en" : _d;
    var url = new URL("".concat(window.location.origin, "/share/report/").concat(token));
    url.searchParams.set("channel", "qr");
    if (shareRecordId) {
        url.searchParams.set("share_record_id", shareRecordId);
    }
    url.searchParams.set("lang", normalizeShareLanguage(language));
    if (passwordRequired === true ||
        passwordRequired === "true" ||
        passwordRequired === 1 ||
        passwordRequired === "1") {
        url.searchParams.set("password_required", "1");
    }
    return url.toString();
};
var PrimaryActionButton = function (_a) {
    var loading = _a.loading, children = _a.children, props = __rest(_a, ["loading", "children"]);
    return (_jsx(Button, __assign({ variant: "contained", className: "button-all", disabled: loading || props.disabled, sx: { minWidth: PRIMARY_BUTTON_MIN_WIDTH, py: 1, px: 3 } }, props, { children: loading ? _jsx(CircularProgress, { size: 20, color: "inherit" }) : children })));
};
var ShareReportDialog = function (_a) {
    var open = _a.open, examRecord = _a.examRecord, onClose = _a.onClose, translate = _a.translate;
    var dataProvider = useDataProvider();
    var notify = useNotify();
    var locale = useLocale();
    var _b = useState(0), tab = _b[0], setTab = _b[1];
    var _c = useState(""), email = _c[0], setEmail = _c[1];
    var _d = useState(DEFAULT_DOWNLOAD_LIMIT), downloadLimit = _d[0], setDownloadLimit = _d[1];
    var _e = useState(DEFAULT_VALID_MINUTES), validMinutes = _e[0], setValidMinutes = _e[1];
    var _f = useState(false), passwordRequired = _f[0], setPasswordRequired = _f[1];
    var _g = useState(false), isSendingEmail = _g[0], setIsSendingEmail = _g[1];
    var _h = useState(false), isGeneratingQr = _h[0], setIsGeneratingQr = _h[1];
    var _j = useState(null), qrData = _j[0], setQrData = _j[1];
    var qrSvgRef = useRef(null);
    var resetState = function () {
        setTab(0);
        setEmail("");
        setDownloadLimit(DEFAULT_DOWNLOAD_LIMIT);
        setValidMinutes(DEFAULT_VALID_MINUTES);
        setPasswordRequired(false);
        setIsSendingEmail(false);
        setIsGeneratingQr(false);
        setQrData(null);
    };
    var handleClose = function () {
        resetState();
        onClose();
    };
    var handleDialogClose = function () {
        if (isSendingEmail || isGeneratingQr)
            return;
        handleClose();
    };
    useEffect(function () {
        if (open) {
            setQrData(null);
            setDownloadLimit(DEFAULT_DOWNLOAD_LIMIT);
            setValidMinutes(DEFAULT_VALID_MINUTES);
            setPasswordRequired(false);
        }
    }, [examRecord === null || examRecord === void 0 ? void 0 : examRecord.id, open]);
    var generateQrShare = function () { return __awaiter(void 0, void 0, void 0, function () {
        var shareSettings, result, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    shareSettings = parseShareSettings(downloadLimit, validMinutes);
                    if (!(examRecord === null || examRecord === void 0 ? void 0 : examRecord.id) || isGeneratingQr || !shareSettings) {
                        notify(translate("pages.exam.share.invalidQrSettings"), { type: "warning" });
                        return [2 /*return*/];
                    }
                    setIsGeneratingQr(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, dataProvider.createReportQrShare({
                            data: {
                                examId: examRecord.id,
                                download_limit: shareSettings.download_limit,
                                valid_seconds: shareSettings.valid_seconds,
                                password_required: passwordRequired,
                            },
                        })];
                case 2:
                    result = _a.sent();
                    setQrData(result.data);
                    return [3 /*break*/, 5];
                case 3:
                    error_1 = _a.sent();
                    console.error(error_1);
                    notify(translate("pages.exam.share.qrFailed"), { type: "error" });
                    return [3 /*break*/, 5];
                case 4:
                    setIsGeneratingQr(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var handleSendEmail = function () { return __awaiter(void 0, void 0, void 0, function () {
        var trimmedEmail, shareSettings, result, error_2;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    trimmedEmail = email.trim();
                    shareSettings = parseShareSettings(downloadLimit, validMinutes);
                    if (!trimmedEmail || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(trimmedEmail)) {
                        notify(translate("pages.exam.share.invalidEmail"), { type: "warning" });
                        return [2 /*return*/];
                    }
                    if (!(examRecord === null || examRecord === void 0 ? void 0 : examRecord.id) || !shareSettings) {
                        notify(translate("pages.exam.share.invalidQrSettings"), { type: "warning" });
                        return [2 /*return*/];
                    }
                    setIsSendingEmail(true);
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, dataProvider.shareReportByEmail({
                            data: {
                                examId: examRecord.id,
                                destination_email: trimmedEmail,
                                download_limit: shareSettings.download_limit,
                                valid_seconds: shareSettings.valid_seconds,
                                password_required: passwordRequired,
                                lang: normalizeShareLanguage(locale),
                            },
                        })];
                case 2:
                    result = _b.sent();
                    if ((_a = result.data) === null || _a === void 0 ? void 0 : _a.password_required) {
                        notify(translate("pages.exam.share.emailSentWithPassword"));
                    }
                    else {
                        notify(translate("pages.exam.share.emailSent"));
                    }
                    resetState();
                    onClose();
                    return [3 /*break*/, 5];
                case 3:
                    error_2 = _b.sent();
                    console.error(error_2);
                    notify(translate("pages.exam.share.emailFailed"), { type: "error" });
                    return [3 /*break*/, 5];
                case 4:
                    setIsSendingEmail(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var handleCopyLink = function () { return __awaiter(void 0, void 0, void 0, function () {
        var error_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(qrData === null || qrData === void 0 ? void 0 : qrData.token))
                        return [2 /*return*/];
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, navigator.clipboard.writeText(getShareReportUrl(qrData.token, {
                            shareRecordId: qrData.id,
                            passwordRequired: qrData.password_required,
                            language: locale,
                        }))];
                case 2:
                    _a.sent();
                    notify(translate("pages.exam.share.linkCopied"));
                    return [3 /*break*/, 4];
                case 3:
                    error_3 = _a.sent();
                    console.error(error_3);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var handleCopyPassword = function () { return __awaiter(void 0, void 0, void 0, function () {
        var error_4;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(qrData === null || qrData === void 0 ? void 0 : qrData.password))
                        return [2 /*return*/];
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, navigator.clipboard.writeText(String(qrData.password))];
                case 2:
                    _a.sent();
                    notify(translate("pages.exam.share.passwordCopied"));
                    return [3 /*break*/, 4];
                case 3:
                    error_4 = _a.sent();
                    console.error(error_4);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var handleDownloadQrCode = function () {
        if (!qrSvgRef.current)
            return;
        try {
            downloadQrAsPng(qrSvgRef.current);
            notify(translate("pages.exam.share.qrDownloaded"));
        }
        catch (error) {
            console.error(error);
            notify(translate("pages.exam.share.qrDownloadFailed"), { type: "error" });
        }
    };
    var shareUrl = (qrData === null || qrData === void 0 ? void 0 : qrData.token)
        ? getShareReportUrl(qrData.token, {
            shareRecordId: qrData.id,
            passwordRequired: qrData.password_required,
            language: locale,
        })
        : "";
    var isBusy = isSendingEmail || isGeneratingQr;
    return (_jsxs(Dialog, { open: open, TransitionComponent: Transition, onClose: handleDialogClose, keepMounted: true, sx: dialogPaperSx, children: [_jsx(dialog.header, { title: translate("pages.exam.share.title"), handleClose: handleDialogClose }), _jsxs(DialogContent, { sx: { px: 3, pb: 3, pt: 0 }, children: [_jsxs(Tabs, { value: tab, onChange: function (_, value) {
                            if (isBusy)
                                return;
                            setTab(value);
                        }, variant: "fullWidth", sx: { mb: 2 }, children: [_jsx(Tab, { label: translate("pages.exam.share.email"), disabled: isBusy }), _jsx(Tab, { label: translate("pages.exam.share.qrCode"), disabled: isBusy })] }), tab === 0 && (_jsxs(Box, { sx: tabPanelSx, children: [_jsxs(Grid, { container: true, spacing: 2, children: [_jsx(Grid, { item: true, xs: 12, children: _jsx(TextField, { fullWidth: true, label: translate("pages.exam.share.destinationEmail"), value: email, onChange: function (e) { return setEmail(e.target.value); }, type: "email", autoComplete: "email", disabled: isSendingEmail }) }), _jsx(Grid, { item: true, xs: 12, children: _jsx(TextField, { fullWidth: true, type: "number", label: translate("pages.exam.share.downloadLimit"), value: downloadLimit, onChange: function (e) { return setDownloadLimit(e.target.value); }, inputProps: { min: 1 }, disabled: isSendingEmail }) }), _jsx(Grid, { item: true, xs: 12, children: _jsx(TextField, { fullWidth: true, type: "number", label: translate("pages.exam.share.validityMinutes"), value: validMinutes, onChange: function (e) { return setValidMinutes(e.target.value); }, inputProps: { min: 1 }, disabled: isSendingEmail }) }), _jsx(Grid, { item: true, xs: 12, children: _jsx(FormControlLabel, { control: _jsx(Checkbox, { checked: passwordRequired, onChange: function (e) { return setPasswordRequired(e.target.checked); }, disabled: isSendingEmail }), label: translate("pages.exam.share.passwordRequired") }) }), _jsx(Grid, { item: true, xs: 12, children: _jsxs(Box, { component: "ul", sx: emailReminderListSx, children: [_jsx(Typography, { component: "li", className: "small-text", sx: { color: SYSTEM_ACCENT }, children: translate("pages.exam.share.emailLinkDeliveryReminder") }), _jsx(Typography, { component: "li", className: "small-text", sx: { color: SYSTEM_ACCENT }, children: translate("pages.exam.share.emailDeliveryReminder") })] }) })] }), _jsx(Box, { sx: actionRowSx, children: _jsx(PrimaryActionButton, { loading: isSendingEmail, onClick: handleSendEmail, children: translate("pages.exam.share.send") }) })] })), tab === 1 && (_jsxs(Box, { sx: tabPanelSx, children: [!(qrData === null || qrData === void 0 ? void 0 : qrData.token) && (_jsxs(_Fragment, { children: [_jsxs(Grid, { container: true, spacing: 2, children: [_jsx(Grid, { item: true, xs: 12, children: _jsx(TextField, { fullWidth: true, type: "number", label: translate("pages.exam.share.downloadLimit"), value: downloadLimit, onChange: function (e) { return setDownloadLimit(e.target.value); }, inputProps: { min: 1 }, disabled: isGeneratingQr }) }), _jsx(Grid, { item: true, xs: 12, children: _jsx(TextField, { fullWidth: true, type: "number", label: translate("pages.exam.share.validityMinutes"), value: validMinutes, onChange: function (e) { return setValidMinutes(e.target.value); }, inputProps: { min: 1 }, disabled: isGeneratingQr }) }), _jsx(Grid, { item: true, xs: 12, children: _jsx(FormControlLabel, { control: _jsx(Checkbox, { checked: passwordRequired, onChange: function (e) { return setPasswordRequired(e.target.checked); }, disabled: isGeneratingQr }), label: translate("pages.exam.share.passwordRequired") }) })] }), _jsx(Box, { sx: actionRowSx, children: _jsx(PrimaryActionButton, { loading: isGeneratingQr, onClick: generateQrShare, children: translate("pages.exam.share.confirmGenerateQr") }) })] })), (qrData === null || qrData === void 0 ? void 0 : qrData.token) && (_jsxs(_Fragment, { children: [_jsxs(Box, { display: "flex", flexDirection: "column", alignItems: "center", flex: 1, gap: 2, width: "100%", children: [_jsx(Box, { sx: {
                                                    width: 200,
                                                    height: 200,
                                                    p: 1,
                                                    bgcolor: "#FFFFFF",
                                                    border: "1px solid #dde3ea",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                }, children: _jsx(QRCodeSVG, { ref: qrSvgRef, value: shareUrl, size: 184, bgColor: "#FFFFFF", fgColor: SYSTEM_DARK }) }), _jsxs(Box, { sx: qrDescriptionSx, children: [_jsx(Typography, { className: "small-text", sx: { color: SYSTEM_ACCENT, textAlign: "center", mb: 1.25 }, children: translate("pages.exam.share.qrHint") }), qrData.expires_at && (_jsxs(Box, { sx: qrDescriptionRowSx, children: [_jsxs(Typography, { component: "span", className: "small-text", sx: { color: SYSTEM_ACCENT }, children: [translate("pages.exam.share.expiresAt"), ":"] }), _jsx(Typography, { component: "span", className: "small-text", sx: { color: "#000000", textAlign: "right" }, children: dbDateHelperWithHHMM(qrData.expires_at) })] })), qrData.download_limit != null && (_jsxs(Box, { sx: qrDescriptionRowSx, children: [_jsxs(Typography, { component: "span", className: "small-text", sx: { color: SYSTEM_ACCENT }, children: [translate("pages.exam.share.downloadLimit"), ":"] }), _jsx(Typography, { component: "span", className: "small-text", sx: { color: "#000000", textAlign: "right" }, children: qrData.download_limit })] })), qrData.password_required && qrData.password && (_jsxs(Box, { sx: qrDescriptionRowSx, children: [_jsxs(Typography, { component: "span", className: "small-text", sx: { color: SYSTEM_ACCENT }, children: [translate("pages.exam.share.accessPassword"), ":"] }), _jsxs(Box, { display: "flex", alignItems: "center", justifyContent: "flex-end", gap: 0.25, children: [_jsx(Typography, { component: "span", className: "small-text", sx: { color: "#000000", letterSpacing: "0.15em" }, children: qrData.password }), _jsx(Tooltip, { title: translate("pages.exam.share.copyPassword"), children: _jsx(IconButton, { size: "small", "aria-label": translate("pages.exam.share.copyPassword"), onClick: handleCopyPassword, sx: { color: SYSTEM_ACCENT, p: 0.25 }, children: _jsx(ContentCopyIcon, { sx: { fontSize: "0.95rem" } }) }) })] })] }))] })] }), _jsxs(Box, { sx: secondaryActionRowSx, children: [_jsx(Button, { variant: "contained", className: "button-all", onClick: handleCopyLink, fullWidth: true, sx: qrActionButtonSx, children: translate("pages.exam.share.copyLink") }), _jsx(Button, { variant: "contained", className: "button-all", onClick: handleDownloadQrCode, fullWidth: true, sx: qrActionButtonSx, children: translate("pages.exam.share.downloadQrCode") })] })] }))] }))] })] }));
};
export default ShareReportDialog;
